import * as React from 'react';
import CenteredPageContainer from 'src/components/CenteredPageContainer';
import NavBar from 'src/components/NavBar';
import styled from 'styled-components';
import { Container, Row, Col } from 'reactstrap';
import { FullWidthContainer, NoGutterRow, NoPaddingCol } from 'src/components/Grid/FullWidthGrid';
import MapView from '../../components/MapView';
import anytimepickup from 'src/assets/icons/anytimepickup.svg';
import freeins from 'src/assets/icons/freeins.svg';
import helpitems from 'src/assets/icons/helpitems.svg';
import {
  PersonTextContainer,
  PersonApartmentInfoContainer,
  PersonApartmentInfoText,
  PersonNameText,
  PerkImage,
  PerkItem,
  PerksContainer,
} from 'src/components/MatchComponents/PersonDetails';
import TotalPricingComponent from '../../components/TotalPricingComponent';
import ErrorPage from '../MatchPage/components/ErrorPage';
import { Item } from '../MatchPage/MatchPage';
import DateDropoffPickup from 'src/components/MatchComponents/DateDropoffPickup';
import * as moment from 'moment';
import { RouteComponentProps } from 'react-router-dom';

const ThankYouContainer = styled.div`
  background: #00144d;
  height: 212px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const ProfilePicture = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 22px;
  border: 2px solid #ffffff;
  background-color: black;
  z-index: 100;
  margin-bottom: 12px;
`;

const ThanksForStoringWithUsText = styled.h1`
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 24px;
  text-align: center;

  color: #ffffff;
`;

const DetailText = styled.p`
  font-style: normal;
  font-weight: normal;
  line-height: 20px;
  font-size: 14px;
  text-align: center;

  color: rgba(255, 255, 255, 0.6);
`;

const NumberContainer = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid #bdbdbd;
  box-sizing: border-box;
  border-style: dashed;
  border-radius: 4px;
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 20px;
  text-align: center;
  padding: 12px;

  color: #ffffff;
`;

interface state {
  listing: any;
  items: Item[];
  startDate: string;
  endDate: string;
}

interface props {
  id: string;
}

class PostCheckoutPage extends React.Component<RouteComponentProps<props>, state> {
  state = {
    listing: this.props.location.state !== undefined ? this.props.location.state.listing : null,
    items: this.props.location.state !== undefined ? this.props.location.state.items : null,
    startDate: this.props.location.state !== undefined ? this.props.location.state.startDate : null,
    endDate: this.props.location.state !== undefined ? this.props.location.state.endDate : null,
  };

  render() {
    if (this.state.listing === undefined || this.state.listing == null) {
      return <ErrorPage />;
    }
    return (
      <CenteredPageContainer>
        <NavBar colorInverted />
        <ThankYouContainer>
          <Container>
            <Row>
              <Col lg={{ size: 4, offset: 4 }} xl={{ size: 4, offset: 4 }}>
                <ThanksForStoringWithUsText style={{ marginTop: 10 }}>
                  Thanks for storing with us!
                </ThanksForStoringWithUsText>
              </Col>
            </Row>
            <Row>
              <Col lg={{ size: 8, offset: 2 }} xl={{ size: 6, offset: 3 }}>
                <DetailText style={{ marginTop: 8 }}>
                  An email confirmation has been sent to you. Didn't recieve the email? Check your
                  junk folder just in case. Text {this.state.listing.owner.firstName} a week before
                  your scheduled dropoff date to coordinate a meeting time with them.
                </DetailText>
              </Col>
            </Row>
            <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <NumberContainer>{this.state.listing.owner.phoneNumber}</NumberContainer>
            </Row>
          </Container>
        </ThankYouContainer>
        <FullWidthContainer fluid>
          <NoGutterRow style={{ height: 'calc(100vh - 300px)' }}>
            <NoPaddingCol sm={{ size: 12 }} md={{ size: 4 }}>
              <div style={{ marginLeft: 45, marginTop: 40, marginRight: 30 }}>
                <PersonTextContainer>
                  <ProfilePicture src={this.state.listing.owner.profilePicture!} alt="oops" />
                  <PersonNameText>
                    {this.state.listing.owner.firstName} {this.state.listing.owner.lastName}
                  </PersonNameText>
                  <PersonApartmentInfoContainer style={{ marginTop: 4 }}>
                    <PersonApartmentInfoText>
                      {this.state.listing.address} <br /> {this.state.listing.notes}
                    </PersonApartmentInfoText>
                  </PersonApartmentInfoContainer>
                </PersonTextContainer>
                <hr />
                <DateDropoffPickup
                  startDate={moment(this.state.startDate)}
                  endDate={moment(this.state.endDate)}
                />
                <hr />
                <PerksContainer style={{ marginBottom: 20 }}>
                  <PerkItem>
                    <PerkImage src={freeins} /> Money Back Guarantee
                  </PerkItem>

                  <PerkItem>
                    <PerkImage src={helpitems} />
                    Free Insurance
                  </PerkItem>

                  <PerkItem>
                    <PerkImage src={anytimepickup} />
                    Pickup Anytime
                  </PerkItem>
                </PerksContainer>
                <hr />
                <TotalPricingComponent items={this.state.items} />
              </div>
            </NoPaddingCol>
            <NoPaddingCol sm={{ size: 12 }} md={{ size: 8 }}>
              <MapView
                zoom={17}
                center={{
                  lat: this.state.listing.location.latitude,
                  lng: this.state.listing.location.longitude,
                }}
                style={{ height: '100%' }}
              />
            </NoPaddingCol>
          </NoGutterRow>
        </FullWidthContainer>
      </CenteredPageContainer>
    );
  }
}

export default PostCheckoutPage;



// WEBPACK FOOTER //
// ./src/pages/PostCheckout/PostCheckoutPage.tsx